import Spline from '@splinetool/react-spline';

const SoUI = () => {
  return (
    <Spline className="aud-spline" scene="https://prod.spline.design/dTCTxZHRDPEzBuqh/scene.splinecode" />
  );
}

export default SoUI;